import React from 'react'
import styled from 'styled-components'
import { Block, ButtonGroup, Text } from '@mote/ui'

export const Popup = ({ buttons, title, content, width = 320 }) => {
  return (
    <Root gap={16} style={{ width }}>
      <Text fontWeight={500} fontSize={17}>
        {title}
      </Text>
      <main>{content}</main>
      <ButtonGroupStyled>{buttons}</ButtonGroupStyled>
    </Root>
  )
}

const Root = styled(Block)`
  font-family: DM Sans;
  position: absolute;
  z-index: 9999;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  padding: 24px 32px;
  background: white;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.04), 0px 3px 14px rgba(0, 0, 0, 0.08),
    0px 8px 32px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-sizing: border-box;
`

const ButtonGroupStyled = styled(ButtonGroup)`
  button {
    flex: 1;
  }
`
